import profileCorp from './profile'

export default [
  {
    path: '/profile-corp',
    name: 'profileCorp',
    component: profileCorp,
    meta: {
      requiresAuth: true
    }
  }
]
